import { render } from "./FormEditSubtask.vue?vue&type=template&id=6be5fbfd&scoped=true"
import script from "./FormEditSubtask.vue?vue&type=script&lang=js"
export * from "./FormEditSubtask.vue?vue&type=script&lang=js"

import "./FormEditSubtask.vue?vue&type=style&index=0&id=6be5fbfd&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be5fbfd"]])

export default __exports__